import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import axios from 'axios';
// core components
import Button from "components/CustomButtons/Button.jsx";

import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';

class AgreementUpload extends React.Component {
  constructor(props) {
    super(props);
    var userId = ''
    if (this.props.userId) {
      userId = this.props.userId
    }
    this.state = {
      file: null,
      userId: userId
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount(){
    this._isMounted = true;
  }

  handleFileChange(e) {
    e.preventDefault();
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', this.state.userId);
    axios.post(`${API_ROOT}/patientAgreement/`, formData, { headers: getApiHeaders() })
      .then(res => this.handleFileUploadResponse(res));
  }
  handleFileUploadResponse(res) {
    if (res.data.status === 'success') {
      this.props.updateFunction()
    } else {
      alert(res.data.error)
    }
  }
  handleClick() {
    this.refs.fileInput.click();
  }

  render() {
    var {
      addButtonProps
    } = this.props;
    return (
      <div className="fileinput text-center">
        <input type="file" onChange={this.handleFileChange} ref="fileInput" />
        <div>
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
             upload new agreement
            </Button>
        </div>
      </div>
    );
  }
}

AgreementUpload.propTypes = {
  addButtonProps: PropTypes.object
};

export default AgreementUpload;
